import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as PaymentCard } from 'assets/images/payment-card-default.svg';

export const Container = styled.div`
  padding: 10px 18px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray7};
  align-items: center;

  & span.MuiSwitch-thumb {
    color: ${ColorPalette.HEX.AntiFlashWhite2};
  }
  & .MuiSwitch-colorSecondary.Mui-checked span {
    color: ${({ theme }) => theme.primaryBackgroundColor} !important;
  }
`;

export const Item: any = styled.div`
  display: flex;
  flex-direction: column;
`;

Item.Title = styled.div`
  font-size: 16px;
  color: ${ColorPalette.HEX.CharlestonGreen};
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 3px;
`;

Item.Card = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: ${ColorPalette.HEX.Manatee};
  line-height: 1.5;
`;

Item.Icon = styled.img`
  width: 19px;
  height: 19px;
  margin-right: 4px;
  vertical-align: middle;
`;

export const PaymentCardIcon = styled(PaymentCard)`
  color: ${ColorPalette.HEX.BlackOlive2};
  width: 19px;
  height: 19px;
  margin-right: 4px;
  vertical-align: middle;
`;

Item.Switch = styled.div``;
